/* =================================================================
   br-about-introduction — blur-to-clear reveal.

   The &Fold donor uses Webflow IX2 for animate="text". The observer
   mechanics live in the shared br-motion-reveal utility; this file
   keeps only the section's wiring: the statement is hidden via the
   section's data-reveal-ready attribute (CSS in br-about-introduction.css),
   the donor's 15% scroll offset + 0.2 threshold is measured on the
   SECTION, and revealing adds the statement's visible class.
   ================================================================= */
(function () {
  if (!window.brMotion || !window.brMotion.reveal) return;

  window.brMotion.reveal({
    scope: '.br-about-introduction',
    target: '[data-br-about-introduction-reveal]',
    observe: 'scope',
    rootMargin: '0px 0px -15% 0px',
    threshold: 0.2,
    arm: function (section) {
      section.setAttribute('data-reveal-ready', '');
    },
    reveal: function (section, item) {
      item.classList.add('br-about-introduction__statement--visible');
    },
  });
})();
